import { useMemo } from "react";
import { Map, APIProvider, useApiIsLoaded } from "@vis.gl/react-google-maps";

import googleMapsConfig from "../../Auth/GoogleMapsConfig";

const apiKey = googleMapsConfig.googleMapsKey;

const containerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = {
  lat: -3.745,
  lng: -38.523,
};

const MapWrapper = ({ children, ...props }) => {
  const isLoaded = useApiIsLoaded();

  if (!isLoaded) return null;

  return <Map {...props}>{children}</Map>;
};

export const MapContent = ({ zoom = 10, children, centerCoordinate }) => {
  const libraries = useMemo(() => ["drawing", "places"], []);

  return (
    <APIProvider apiKey={apiKey} libraries={libraries}>
      <MapWrapper
        mapId="map-example"
        mapContainerStyle={containerStyle}
        defaultCenter={centerCoordinate || defaultCenter}
        defaultZoom={zoom}
        disableDefaultUI
      >
        {children}
      </MapWrapper>
    </APIProvider>
  );
};
